<!-- ================二级代理-卡管理====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">卡列表</div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">卡类型:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)" v-model="queryParams.cardType" placeholder="请选择">
                        <el-option v-for="item in cardTypeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">是否激活:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="pageList(null)" v-model="queryParams.isActivate" placeholder="请选择">
                        <el-option v-for="item in activeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.cardNo" placeholder="请输入卡编号" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 225px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" align="center" label="序号" width="60" />
                <el-table-column  label="卡编号" width="200"  align="center" prop="cardNo">
                    <template #default="scope">
                        <div :title="scope.row.cardNo" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.cardNo }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="卡类型" prop="cardType">
                    <template #default="scope">
                        <div type="success" v-if="scope.row.cardType === 1">B卡</div>
                        <div type="success" v-if="scope.row.cardType === 2">C卡</div>
                        <div type="success" v-if="scope.row.cardType === 3">课程卡</div>
                    </template>
                </el-table-column>
                <el-table-column  label="卡年限" width="80"  align="center" prop="cardYear">
                    <template #default="scope">
                        <div :title="scope.row.cardYear" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.cardYear }}年
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="一级代理" prop="supplierName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.supplierName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.supplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="二级代理" prop="secondSupplierName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.secondSupplierName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.secondSupplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="是否激活" prop="isActivate">
                    <template #default="scope">
                        <el-tag type="info" v-if="scope.row.isActivate == 0">未激活</el-tag>
                        <el-tag type="success" v-if="scope.row.isActivate == 1">已激活</el-tag>
                    </template>
                </el-table-column>
                <el-table-column width="200"  label="激活机构" prop="orgName" align="center" >
                    <template #default="scope">
                        <div :title="scope.row.orgName" style="color: #377f7f;" class="text-one cursor">
                            {{ scope.row.orgName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popconfirm
                          confirm-button-text="是"
                          cancel-button-text="否"
                          icon-color="#626AEF"
                          title="确定退回此卡到代理商?"
                          @confirm="handleBackSupplier(scope.row)">
                            <template #reference>
                                <el-button v-if="scope.row.isActivate === 0"
                                           type="warning" size="small">退回卡</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false" :pageSizes="[10, 20, 30]" :total="total"
                        v-model:page.sync="queryParams.pageNum" v-model:limit.sync="queryParams.pageSize" @pagination="pageList" />
        </div>
    </div>
</template>
<script>
import {pageCard,backCard} from "@/api/admin/card"
import {secondSupplierInfo} from "@/api/admin/supplier";
import {timestampDate, timestampToTime} from "@/utils/date";

export default {
    components: {},
    name: "supplier2CardIndex",
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            activeList: [
                { name: '未激活', value: 0 },
                { name: '已激活', value: 1 },
            ],
            cardTypeList: [
                { name: 'B卡', value: 1 },
                { name: 'C卡', value: 2 },
                { name: '课程卡', value: 3 },
            ],
            /*分页查询卡*/
            queryParams:{
                supplierId:'',
                secondSupplierId:'',
                cardNo:'',
                isActivate:'',
                cardType:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            // 二级代理信息
            supplierId:'',
            supplierInfo:{},
            // 退回卡到一级代理
            backCardForm:{
                cardNos:"",
                backType:2,
            }
        }
    },
    computed: {},
    watch: {},
    created() {
        this.querySecondSupplierInfo();
    },
    mounted() {},
    methods: {
        /*===========代理============*/
        // 查询二级代理信息
        querySecondSupplierInfo(){
            secondSupplierInfo().then(res => {
                if (res.data.code === 1) {
                    this.supplierInfo = res.data.data;
                    this.supplierId = this.supplierInfo.supplierId;
                    this.queryParams.secondSupplierId = this.supplierId;
                    this.pageList();
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        /*===========卡数据查询============*/
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageCard(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        /*===========卡管理============*/
        // 退回卡到一级代理
        handleBackSupplier(item){
            this.backCardForm.cardNos = item.cardNo;
            backCard(this.backCardForm).then(res => {
                if (res.data.code === 1) {
                    this.pageList(null)
                }else {
                    this.$message.error("请求出错")
                }
            })
        }
    },
}
</script>
<style scoped>
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
